import React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner} from '@fortawesome/free-solid-svg-icons';

import './UploadList.css';


class UploadListNew extends React.Component{
constructor(props){
super(props)
  this.state = {
    selectedFile: null,
    isUploading:false,
  }
}
  fileChangedHandler = (event) => {
    this.setState({selectedFile: event.target.files[0]}, function(){
      console.log(this.state.selectedFile)
    })
  }

  uploadCollectorHandler = () => {
    var data = new FormData()
    this.setState({isUploading:true},function(){
      console.log('uploading')
    })
    data.append('collectorFile', this.state.selectedFile);
      data.append('school', localStorage.getItem('schoolToken'));
    fetch('https://schoolportal.appsdesign.co.za/upload_collector_file', {
      method: 'POST',
      body: data
    })
    .then(res =>
this.setState({
  isUploading:false,
selectedFile: null,
},function(){
  alert('List has been uploaded')
}

)


    )
    .catch(err =>

        alert('The was an error, please try again later')

    )

  }

  uploadClassHandler = () => {
    var data = new FormData()
    this.setState({isUploading:true},function(){
      console.log('uploading')
    })
    data.append('classFile', this.state.selectedFile)
    data.append('school', localStorage.getItem('schoolToken'));
    fetch('https://schoolportal.appsdesign.co.za/upload_class_file', {
      method: 'POST',
      body: data
    })
    .then(res =>
      this.setState({
        isUploading:false,
        selectedFile: null,
      },function(){
        alert('List has been uploaded')
      }

      )

    )
    .catch(err =>


        alert('The was an error, please try again later')


    )

  }


  uploadChildHandler = () => {
    var data = new FormData()
this.setState({isUploading:true},function(){
  console.log('uploading');

})
data.append('childFile', this.state.selectedFile);
  data.append('school', localStorage.getItem('schoolToken'));
    fetch('https://schoolportal.appsdesign.co.za/upload_child_file', {
      method: 'POST',
      body: data
    })
    .then(res => res.json())
    .then(resJSON =>{
      console.log(resJSON);
      if(resJSON.status !== 'ok'){
        alert('List could not be uploaded')
      }
      else{
      this.setState({
        isUploading:false,
        selectedFile: null,
      },function(){
        alert('List has been uploaded')
      }

      )
    }

    })
    .catch(err =>

        alert('The was an error, please try again later')


    )

  }






render(){





return(


  this.state.isUploading ?

      <div>
        <div id="tex">Uploading your file, please wait ....</div>
          <FontAwesomeIcon icon={faSpinner} size="5x" color='lavender' pulse/>
      </div>
      :
  <div>


  <div>


<div className="ma2 pa2 br3 shadow-4" style={{backgroundColor:'white', padding:20, margin:10}}>

<h3>Upload Collector file</h3>
<input type="file" name="collectorFile" onChange={this.fileChangedHandler}/>
<button className="br3 pa3 bg-blue br-blue" onClick={this.uploadCollectorHandler}>Upload</button>


</div>

<div className="ma2 pa2 br3 shadow-4" style={{backgroundColor:'white', padding:20, margin:10}}>

<h3>Upload Class file</h3>
<input type="file" name="classFile" onChange={this.fileChangedHandler}/>
<button className="br3 pa3 bg-blue br-blue" onClick={this.uploadClassHandler}>Upload</button>


</div>

<div className="ma2 pa2 br3 shadow-4" style={{backgroundColor:'white', padding:20, margin:10}}>

<h3>Upload Child file</h3>
<input type="file" name="childFile" onChange={this.fileChangedHandler}/>
<button className="br3 pa3 bg-blue br-blue" onClick={this.uploadChildHandler}>Upload</button>


</div>

</div>
  </div>

)

}

}

export default UploadListNew;



// WEBPACK FOOTER //
// ./src/components/UploadList/UploadListNew.js